<template>
    <div>
        <table class="table table-striped">
            <thead>
                <tr>
                    <th>Product</th>
                    <th>ISBN</th>
                    <th>Voorraad</th>
                    <th>Prijs excl.</th>
                    <th>Prijs</th>
                    <th>Aantal</th>
                    <th v-show="!isStockMovement">Korting (%)</th>
                    <th v-show="!isStockMovement">Korting omschrijving</th>
                    <th>BTW (%)</th>
                    <th>Totaal excl.</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <order-line
                    v-for="(orderLine, index) in orderLines"
                    :data="orderLine"
                    @destroy="removeOrderLine(index)"
                    @select="addOrderLine"
                    :key="index"
                    :line-key="index"
                    :is-stock-movement="isStockMovement"
                >
                </order-line>
                <tr>
                    <td colspan="9" class="text-right">Totaalprijs: </td>
                    <td>{{ orderTotal }}</td>
                </tr>
            </tbody>
        </table>
        <div class="pull-right mb5 mt5">
            <input type="button" @click="addOrderLine" class="btn btn-success" value="Nieuwe regel" />
        </div>
    </div>
</template>

<script>
import OrderLine from "./OrderLine";
import {EventBus} from "../../events";
export default {
    name: "CreateEditOrder",
    components: {OrderLine},
    props: {
        currentOrderLines: {
            required: false,
            type: Array,
        },
        isStockMovement: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            orderLines: [],
            pricegroup: 0,
            linePrices: [],
        }
    },
    methods: {
        addOrderLine() {
            this.orderLines.push({pricegroup: this.pricegroup});
        },
        removeOrderLine(index) {
            this.orderLines.splice(index, 1);
        }
    },
    created() {
        if(this.currentOrderLines.length){
            let vue = this;
            _.forEach(this.currentOrderLines, function(orderLine, i){
                vue.orderLines.push(orderLine);
            });
        }
        else{
            this.addOrderLine();
        }
    },
    mounted() {
        EventBus.$on('changePricegroup', (pricegroup) => {
            this.pricegroup = pricegroup;
        });
        EventBus.$on('lineUpdate', (line) => {
            let found = false;
            let price = 0;
            this.linePrices.forEach(function(linePrice) {
                if(linePrice.key == line.key) {
                    linePrice.price = (line.price - (line.price * (line.discount) / 100)).toFixed(2) * line.quantity;
                    found = true;
                }
            })

            if( ! found) {
                this.linePrices.push({
                    key: line.key,
                    price: (line.price - (line.price * (line.discount) / 100)).toFixed(2) * line.quantity,
                })
            }

            this.totalPrice = price;
        });
    },
    computed: {
        orderTotal() {
            return this.linePrices.reduce(function(total, line){
                return total + parseFloat(line.price);
            }, 0).toFixed(2)
        },
    }
}
</script>

<style scoped>

</style>
